import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchSequences } from '../../actions/sequence';
import { FetchCities } from '../../actions/cities';
import { FetchInfo } from '../../actions/info';
import UpdatePanel from './components/updates-panel';
import Cyaocard from './components/cyao-card';
import BuilderCardStatic from './components/builder-card-static';
import _orderBy from 'lodash/orderBy';
import ResultsText from '../shared/results-text';
import SpinnerWithBackground from '../shared/spinner-background';
import Toggle from 'react-toggle';
import { CYOA_NETWORK_IDS  } from '../../config';
import { getCyoaID } from '../../helpers/cyoaHelper';


const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);

class Sequences extends PureComponent {

  constructor(){
    super();
    this.state = {
      cities:[],
      citiesData:[],
      info:[],
      toggleCheck: (parsed.bundle === 1 || parsed.bundle === undefined ) ? false : true,
      defaultEuropeValues:{
        style: 1,
        optionals:2,
        city:'Paris',
        stops:12,
        bundle:0
      },
      defaultUsaValues:{
        style: 1,
        optionals:2,
        city:'Los Angeles',
        stops:8,
        bundle:0
      },
    }

    this.handleToggleChange = this.handleToggleChange.bind(this);
  }

  componentDidMount(){

    //Scroll window to top
    window.scrollTo(0, 0);
  }

  handleToggleChange(){
    this.setState({toggleCheck: !this.state.toggleCheck});

    const parsed = queryString.parse(window.location.search);
    const { currency, FetchSequences } = this.props;
    const { defaultEuropeValues, defaultUsaValues } = this.state;
    const bundle = this.state.toggleCheck ? 0 : 1;

    let _style = (parsed.style === undefined) ? (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.style : defaultEuropeValues.style ) : parsed.style;
    let _optional = (parsed.optionals === undefined) ?  (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.optionals : defaultEuropeValues.optionals ) : parsed.optionals;
    let _city = (parsed.city === undefined) ? (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.city : defaultEuropeValues.city ) : parsed.city;
    let _stops = (parsed.stops === undefined) ? (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.stops : defaultEuropeValues.stops ) : parsed.stops;

      FetchSequences(
        _style,
        _optional,
        _city,
        currency.iso_currency_code,
        _stops,
        null,
        bundle,
        parsed.custom,
        getCyoaID()
      );


      const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?travelstyle=cyoa&style=" + _style + "&optionals=2&city=" + _city + "&currency=" + currency.iso_currency_code + "&stops=" + _stops + "&bundle=" + bundle;

      if (window.history.pushState) {
          window.history.pushState({path:newurl},'',newurl);
      }


  }


  componentDidUpdate(prevProps, prevState){

    const {
      currency,
      FetchSequences,
      FetchCities, cities,
      FetchInfo,
     } = this.props;

    const { defaultEuropeValues, defaultUsaValues } = this.state;

    if(currency !== prevProps.currency){

      //Fetch Sequences
      // - Random sequence from search bar link
      // - Load from pre-defined from query params

      if(parsed.style === undefined){

        FetchSequences(
          (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.style  : defaultEuropeValues.style ),
          (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.optionals : defaultEuropeValues.optionals ),
          (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.city  : defaultEuropeValues.city ),
          currency.iso_currency_code,
          (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.stops : defaultEuropeValues.stops ),
          null, 
          (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.bundle : defaultEuropeValues.bundle ),
          (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? defaultUsaValues.custom : parsed.custom ),
          (window.location.pathname === CYOA_NETWORK_IDS["usa"].slug ? CYOA_NETWORK_IDS["usa"].id : CYOA_NETWORK_IDS["europe"].id )
          );

      }else{

        FetchSequences(
          parsed.style,
          parsed.optionals,
          parsed.city,
          currency.iso_currency_code,
          parsed.stops,
          null,
          parsed.bundle,
          parsed.custom,
          getCyoaID()
        );
      }


      //Fetch cities
      FetchCities(currency.iso_currency_code, getCyoaID());

      //Fetch info
      FetchInfo(getCyoaID());
    }

    if(cities !== prevProps.cities){
      //Save city countries

      const citiesSorted =  _orderBy(cities, ['city', 'asc']);
      this.setState({citiesData:citiesSorted});
    }

  }


  render(){

    const { citiesData, toggleCheck  } = this.state;
    const { sequences, currency, info, sequencesFetching } = this.props;
    const _sequences = (Object.keys(sequences).length > 0) ? sequences.data : [];
    const _sequencesHeader = (Object.keys(sequences).length > 0) ? sequences.header.params : [];
  

    return (
      <div className="App">
        <div className="row">
          <div className="columns small-12">
              <ResultsText length={_sequences.length} isCyoa={1} />
          </div>
        </div>

        <div className="sequences">
          <div className="row sequences-search-wrapper">
            <div className="columns small-12">
              <UpdatePanel citiesData={citiesData} info={info} sequences={sequences} toggleCheck={toggleCheck} cyoaId={getCyoaID()} />
            </div>
          </div>



          <div className="row sequences-wrapper">

            { _sequences.length > 0 &&
            <div className="columns small-12">
              <label className="toggle">
                <span>Include bundles</span>
                <Toggle defaultChecked={toggleCheck} onChange={this.handleToggleChange} />
              </label>
            </div>
            }

            { sequencesFetching &&  <SpinnerWithBackground text="Loading itineraries..." bgClass="no-opacity" loadClass="orange-spinner-wrapper" />}
            <BuilderCardStatic cyoaId={getCyoaID()} /> 
            { _sequences.map((item, i) => { return <Cyaocard key={item.sequence_id} data={item} currency={currency} citiesData={citiesData} header={_sequencesHeader} cyoaId={getCyoaID()}  /> }) }
          </div>
        </div>
      </div>
    )
 }
}

function mapStateToProps(state){
  return{
    cities:state.cities.data,
    currency:state.currency,
    sequences:state.sequences,
    info:state.info.data,
    sequencesFetching:state.sequences.isFetching
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchSequences,
    FetchCities,
    FetchInfo
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Sequences);



// WEBPACK FOOTER //
// ./src/components/discover/index.js